// Disable max class per file due to form validation classes
/* eslint-disable max-classes-per-file */

import { IsInt, IsNotEmpty, IsString, ValidateNested, IsOptional } from 'class-validator';

export class TemplateForm {
  @IsInt()
  id: number;

  @IsOptional()
  @IsString()
  @IsNotEmpty()
  name?: string;
}

export class SettingConfigurationForm {
  @IsString()
  @IsNotEmpty()
  name: string;

  @IsOptional()
  @ValidateNested()
  template?: TemplateForm;
}
